{
  "nav": {
    "home": "Home",
    "scouting": "Osservazione",
    "reports": "Rapporti",
    "settings": "Impostazioni"
  },
  "settings": {
    "language": "Lingua",
    "languageDescription": "Scegli la lingua usata in tutta l'applicazione.",
    "save": "Salva"
  },
  "reports": {
    "title": "Rapporti di osservazione",
    "empty": "Nessun rapporto",
    "translationUnavailable": "Traduzione non disponibile. Viene mostrato il rapporto originale.",
    "retryTranslation": "Riprova",
    "matchesHeading_one": "Partita:",
    "matchesHeading_other": "Partite:",
    "matchLineHome": "contro {{opponent}} il {{date}}",
    "matchLineAway": "a {{opponent}} il {{date}}",
    "matchLineNeutral": "{{opponent}} il {{date}}",
    "editorTitle": "Modifica rapporto di osservazione",
    "untitled": "Rapporto",
    "authorSelf": "Tu",
    "sharedBadge": "Condiviso",
    "shareAction": "Condividi",
    "sharedAction": "Condiviso",
    "back": "Indietro",
    "editedBy": "Modificato da",
    "createdBy": "Creato da",
    "translate": "Traduci",
    "translating": "Traduzione...",
    "showOriginal": "Mostra originale",
    "download": "Scarica",
    "downloading": "Download...",
    "edit": "Modifica",
    "archive": "Archivia"
  },
  "language": {
    "control": "Lingua",
    "selectTitle": "Seleziona lingua",
    "change": "Cambia lingua",
    "changeCurrent": "Cambia lingua, attualmente {{language}}",
    "changeStranded": "Cambia lingua. La lingua salvata {{code}} non è più disponibile, quindi viene usato {{language}}.",
    "generate": "Genera · {{language}}",
    "generateAccessibility": "Lingua del riepilogo generato",
    "saveDefault": {
      "idle": "Salva come lingua predefinita",
      "saving": "Salvataggio…",
      "saved": "Salvata come lingua predefinita",
      "alreadyDefault": "Questa è già la lingua predefinita",
      "error": "Salvataggio non riuscito — tocca per riprovare",
      "warning": "Vale solo per questo riepilogo. Salvala come lingua predefinita, altrimenti dovrai generarlo di nuovo la prossima volta.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "Impossibile salvare la lingua predefinita. Riprova."
    }
  }
}
